import PlayerSessionActionType from 'actions/playerSession/playerSessionActionType';

const initialState = {
  playerActiveSessions: [],
  applicationSessions: {},
  webSessions: {},
};

const playerSessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case PlayerSessionActionType.SAVE_PLAYER_ACTIVE_SESSIONS:
    return {
      ...state,
      playerActiveSessions: payload.data,
    };
  case PlayerSessionActionType.RESET_PLAYER_ACTIVE_SESSIONS:
    return {
      ...state,
      playerActiveSessions: [],
    };
  case PlayerSessionActionType.SAVE_APPLICATION_SESSIONS:
    return {
      ...state,
      applicationSessions: payload.data,
    };
  case PlayerSessionActionType.RESET_APPLICATION_SESSIONS:
    return {
      ...state,
      applicationSessions: {},
    };
  case PlayerSessionActionType.SAVE_WEB_SESSIONS:
    return {
      ...state,
      webSessions: payload.data,
    };
  case PlayerSessionActionType.RESET_WEB_SESSIONS:
    return {
      ...state,
      webSessions: {},
    };
  default:
    return state;
  }
};

export default playerSessionReducer;
